import { TenantEntity } from '../TenantEntity'

export class UnitLoadDevice extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get isDirty() {
    return this._data.isDirty
  }
  set isDirty(isDirty) {
    this._data.dirty = isDirty
  }
  // =====================非db 字段，关联的装箱信息============
  get unitLoadDeviceUsage() {
    return this._data.unitLoadDeviceUsage
  }
  set unitLoadDeviceUsage(unitLoadDeviceUsage) {
    this._data.unitLoadDeviceUsage = unitLoadDeviceUsage || []
  }
  get airUlds() {
    return this._data.airUlds
  }
  set airUlds(airUlds) {
    this._data.airUlds = airUlds
  }
  // ====================db 字段，关联的装箱信息============
  get unitLoadDeviceId() {
    return this._data.unitLoadDeviceId
  }
  set unitLoadDeviceId(unitLoadDeviceId) {
    this._data.unitLoadDeviceId = unitLoadDeviceId
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get containerType() {
    return this._data.containerType
  }
  set containerType(containerType) {
    this._data.containerType = containerType
  }
  get containerCode() {
    return this._data.containerCode
  }
  set containerCode(containerCode) {
    this._data.containerCode = containerCode
  }
  get containerNumber() {
    return this._data.containerNumber
  }
  set containerNumber(containerNumber) {
    this._data.containerNumber = containerNumber
  }
  get board() {
    return this._data.board
  }
  set board(board) {
    this._data.board = board
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
}
